import { theme } from 'antd';
import React, { useEffect, useState } from 'react';
import { useManagePermittedRoles } from 'library/hooks';
import { useDispatch, useSelector } from 'react-redux';
import { teamsActions } from 'reduxStore/teams/slice';
import { selectSites } from 'reduxStore/sites/selectors';
import { Typography } from 'zui/Antd';
import { SelectFontSizeLG } from 'zui/Antd/Select';

const { Text } = Typography;

const EditSiteSelect = ({ siteID, teamID }) => {
	// ✅ Hooks
	const {
		token: { fontSizeLG }
	} = theme.useToken();
	const dispatch = useDispatch();
	const isGlobalAdmin = useManagePermittedRoles('manageSiteAssignment');
	const canEdit = useManagePermittedRoles('updateTeam');

	// ✅ Redux Selectors
	const sites = useSelector(selectSites);

	// ✅ Local state for editing
	const [editableSiteID, setEditableSiteID] = useState(siteID);

	// ✅ Update editableSiteID when siteID prop changes
	useEffect(() => {
		setEditableSiteID(siteID);
	}, [siteID]);

	// ✅ Handle selection change and dispatch action
	const handleSelectChange = (value) => {
		setEditableSiteID(value);
		dispatch(teamsActions.updateTeam({ teamID, data: { siteID: value } }));
	};

	// ✅ Site options
	const options = sites.map((site) => ({
		label: site.name,
		value: site.siteID
	}));
	const resolvedSite = sites.find((site) => site.siteID === siteID);
	const siteName = resolvedSite?.name || '-';

	const displayValue = resolvedSite ? editableSiteID : null;
	const showSelect = isGlobalAdmin || (canEdit && sites.length > 1);

	if (!showSelect) {
		return <Text style={{ fontSize: fontSizeLG }}>{siteName}</Text>;
	}

	return (
		<SelectFontSizeLG
			value={displayValue}
			onChange={handleSelectChange}
			placeholder={'Select Site'}
			options={options}
			showSearch={false}
			virtual={false}
			style={{
				width: 228
			}}
		/>
	);
};

export default EditSiteSelect;
